import React from "react";

function noServerSnapshot(): never {
  throw Error("useMediaQuery is a client-only hook");
}

export function useMediaQuery<T extends string>(query: T) {
  const subscribe = React.useCallback(
    (callback: () => void) => {
      const matchMedia = window.matchMedia(query);

      matchMedia.addEventListener("change", callback);
      return () => {
        matchMedia.removeEventListener("change", callback);
      };
    },
    [query],
  );

  const getSnapshot = React.useCallback(() => {
    return window.matchMedia(query).matches;
  }, [query]);

  return React.useSyncExternalStore(subscribe, getSnapshot, noServerSnapshot);
}

export function useIsMobile() {
  return useMediaQuery("(width<48rem)");
}
